"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/CircleSocialTwitter.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var CircleSocialTwitter = function CircleSocialTwitter(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "circle-icon",
    viewBox: "0 0 515 515"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Twitter Circle Icon"), _react2.default.createElement("path", {
    d: "M257.5 0C115.29 0 0 115.29 0 257.5S115.29 515 257.5 515 515 399.71 515 257.5 399.71 0 257.5 0zm114.22 198.91c.11 2.54.18 5.09.18 7.65 0 77.86-59.25 167.62-167.66 167.62a166.67 166.67 0 0 1-90.32-26.45 119 119 0 0 0 87.24-24.4 59 59 0 0 1-55-40.93 59.15 59.15 0 0 0 26.6-1 58.93 58.93 0 0 1-47.26-57.78v-.74a58.68 58.68 0 0 0 26.68 7.36 59 59 0 0 1-18.23-78.67 167.31 167.31 0 0 0 121.44 61.58 59 59 0 0 1 100.41-53.76 117.61 117.61 0 0 0 37.43-14.3 59.19 59.19 0 0 1-25.94 32.61 117.14 117.14 0 0 0 33.84-9.27 118.52 118.52 0 0 1-29.41 30.48z",
    className: "circle-twitter",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = CircleSocialTwitter;